import { Group, Modal, TextInput, useMantineTheme } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import AgGridDeviceMeasurementTable, {
  DeviceMeasurementFormData,
} from 'components/forms/revision/fill-out/modals/device-measurement-modal/ag-grid/AgGridDeviceMeasurementTable';
import { IFormInputSpec } from 'pages/revisions-module/template-editor/editors/form/types';
import { useEffect, useState } from 'react';

interface RevisionDeviceMeasurementsModalProps<TMeasurement> {
  deviceName: string;
  deviceTypeId: number;
  measurementType: string;
  opened: boolean;
  onClose: () => void;
  spec: Readonly<IFormInputSpec[]>;
  lockingEnabled: boolean;
  initialValues: DeviceMeasurementFormData<TMeasurement>;
  revisionKind: 'revision' | 'form';
}

/**
 * Displays a read-only measurement table for a device on the revision detail page.
 */
export default function RevisionDeviceMeasurementsModal<TMeasurement>({
  deviceName,
  deviceTypeId,
  measurementType,
  opened,
  onClose,
  spec,
  lockingEnabled,
  initialValues,
  revisionKind,
}: RevisionDeviceMeasurementsModalProps<TMeasurement>) {
  const theme = useMantineTheme();
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (!opened) {
      setSearch('');
    }
  }, [opened]);

  return (
    <Modal.Root opened={opened} onClose={onClose} size="100%" zIndex={100}>
      <Modal.Overlay />
      <Modal.Content h="100%">
        <Modal.Header w="100%" px={24} py={16}>
          <Group w="100%" position="apart">
            <Modal.Title>
              {deviceName} - {measurementType}
            </Modal.Title>
            <TextInput
              miw={360}
              value={search}
              size="md"
              onChange={(event) => setSearch(event.currentTarget.value)}
              placeholder="Hľadať meranie"
              rightSection={<IconSearch stroke={1.5} color={theme.colors.gray[6]} />}
            />
          </Group>
        </Modal.Header>
        <Modal.Body p={0} style={{ height: 'calc(100% - 72px)' }}>
          <AgGridDeviceMeasurementTable
            mode="view"
            deviceTypeId={deviceTypeId}
            initialValues={initialValues}
            onClose={onClose}
            spec={spec}
            lockingEnabled={lockingEnabled}
            hideFaults={false}
            search={search}
            revisionKind={revisionKind}
          />
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
}
